import React from 'react';
import { Link } from 'react-router-dom';
import CarruselProductos from '../components/inicio/CarruselProductos';
import BannerNuevo from '../components/inicio/BannerNuevo';
import SEO from '../components/SEO';

const servicios = [
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
      </svg>
    ),
    titulo: 'Venta de Equipos',
    descripcion: 'Radios portátiles, móviles, repetidoras y accesorios de las marcas líderes del mercado.',
    href: '/productos',
    cta: 'Ver catálogo',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
    titulo: 'Arriendo de Radios',
    descripcion: 'Solución flexible para eventos, operaciones temporales o proyectos de corto y largo plazo.',
    href: '/servicios/arriendo-de-radios',
    cta: 'Más información',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    titulo: 'Servicio Técnico',
    descripcion: 'Reparación, mantención y programación de equipos con técnicos certificados por las marcas.',
    href: '/servicios/servicio-tecnico',
    cta: 'Solicitar servicio',
  },
];

const marcas = ['Motorola', 'Hytera', 'Kenwood', 'Sepura', 'TXPRO', 'Wings'];

/* Encabezado reutilizable de sección */
function SectionHeader({ badge, title, subtitle }) {
  return (
    <div className="text-center mb-10 md:mb-12">
      {badge && (
        <span className="inline-block bg-[#00BEE7]/10 border border-[#00BEE7]/30 text-[#00BEE7] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-3">
          {badge}
        </span>
      )}
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-[#0f274b]">{title}</h2>
      {subtitle && (
        <p className="mt-3 text-gray-500 max-w-xl mx-auto text-base">{subtitle}</p>
      )}
    </div>
  );
}

function Inicio() {
  return (
    <div>
      <SEO
        title="Inicio"
        description="Soluciones de radiocomunicación en Chile: radios Motorola, Hytera, Kenwood y Sepura, arriendo y soporte técnico especializado."
        canonicalPath="/"
      />

      {/* ── 1. BANNER PRINCIPAL ── */}
      <BannerNuevo />

      {/* ── 2. SERVICIOS ── fondo blanco */}
      <div className="py-16 md:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <SectionHeader
            badge="Lo que ofrecemos"
            title="Soluciones integrales de radiocomunicación"
            subtitle="Desde la venta hasta el soporte post-venta, acompañamos a tu empresa en cada etapa."
          />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {servicios.map((servicio) => (
              <div
                key={servicio.titulo}
                className="group bg-white border border-gray-100 rounded-2xl p-7 shadow-sm hover:shadow-xl hover:border-[#00BEE7]/40 transition-all duration-300"
              >
                <div className="flex items-center justify-center w-14 h-14 rounded-xl bg-[#0f274b]/5 text-[#0f274b] group-hover:bg-[#00BEE7]/15 group-hover:text-[#007fa0] transition-all duration-300 mb-5">
                  {servicio.icon}
                </div>
                <h3 className="text-xl font-extrabold text-[#0f274b] mb-2">{servicio.titulo}</h3>
                <p className="text-gray-500 text-base leading-relaxed mb-5">{servicio.descripcion}</p>
                <Link
                  to={servicio.href}
                  className="inline-flex items-center gap-1.5 text-[#00BEE7] font-bold text-base hover:gap-3 transition-all duration-200"
                >
                  {servicio.cta}
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── 3. PRODUCTOS MOTOROLA ── fondo gris */}
      <div className="bg-gray-50 py-4 border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-4 pt-10">
          <SectionHeader
            badge="Catálogo"
            title="Equipos Motorola"
          />
        </div>
        <CarruselProductos
          tipo="Motorola"
        />
      </div>

      {/* ── 4. PRODUCTOS HYTERA ── fondo blanco */}
      <div className="bg-white py-4 border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-4 pt-10">
          <SectionHeader
            badge="Catálogo"
            title="Equipos Hytera"
          />
        </div>
        <CarruselProductos
          tipo="Hytera"
        />
      </div>

      {/* ── 5. MARCAS ── fondo gris */}
      <div className="py-12 bg-gray-50 border-t border-gray-100">
        <div className="max-w-5xl mx-auto px-4">
          <p className="text-center text-xs font-bold uppercase tracking-widest text-gray-400 mb-7">
            Distribuidores autorizados en Chile
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6">
            {marcas.map((marca) => (
              <Link
                key={marca}
                to="/productos"
                className="px-5 py-3 bg-white border border-gray-200 rounded-xl text-[#0f274b] font-extrabold text-base hover:border-[#00BEE7] hover:text-[#007fa0] hover:shadow-md transition-all duration-200"
              >
                {marca}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* ── 6. CTA FINAL ── fondo navy */}
      <div className="relative bg-[#0f274b] py-20 overflow-hidden">
        <div
          className="absolute inset-0 opacity-10"
          style={{ backgroundImage: 'radial-gradient(ellipse at 15% 50%, #00BEE7 0%, transparent 55%), radial-gradient(ellipse at 85% 50%, #00BEE7 0%, transparent 55%)' }}
        />
        <div className="relative max-w-3xl mx-auto px-4 text-center">
          <span className="inline-block bg-[#00BEE7]/20 border border-[#00BEE7]/40 text-[#00BEE7] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-5">
            Hablemos
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-white mb-4 leading-tight">
            ¿Necesitas una solución de comunicación?
          </h2>
          <p className="text-blue-200 text-base mb-10 max-w-xl mx-auto leading-relaxed">
            Cuéntanos tu necesidad y un asesor especializado te contactará sin costo ni compromiso.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contacto"
              className="bg-[#00BEE7] hover:bg-[#00a8cf] text-[#0f274b] font-extrabold px-8 py-3.5 rounded-full text-base transition-all duration-200 shadow-lg shadow-[#00BEE7]/20"
            >
              Hablar con un asesor
            </Link>
            <Link
              to="/servicios/cotizacion"
              className="border-2 border-white/30 hover:border-[#00BEE7] text-white hover:text-[#00BEE7] font-extrabold px-8 py-3.5 rounded-full text-base transition-all duration-200"
            >
              Solicitar cotización
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Inicio;
